import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import NotificationSettings from '../components/NotificationSettings';
import './NotificationSettingsPage.css';

const NotificationSettingsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="notification-settings-page">
      <div className="page-container">
        <button
          className="back-button"
          onClick={() => navigate('/advisor')}
        >
          <ArrowLeft size={20} />
          Back to Dashboard
        </button>

        <NotificationSettings />
      </div>
    </div>
  );
};

export default NotificationSettingsPage;
